import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'lebron.lp.heading',
		defaultMessage: 'Greatness lies on the other side of sleep',
		description: 'Heading for 2021 LeBron landing page',
	},
});
